import type { ValidationResult } from "ember-changeset/types";

// This validator is from https://github.com/skaterdav85/ember-changeset-conditional-validations/

export type ValidationFunction = (
  key: string,
  newValue: unknown,
  oldValue: unknown,
  changes: unknown,
  content: object
) => ValidationResult | Promise<ValidationResult>;

// More flexible type that can accept ember-changeset-validations functions
export type FlexibleValidationFunction = (
  key: string | undefined,
  newValue: any,
  oldValue: any,
  changes: any,
  content: any
) => ValidationResult | Promise<ValidationResult>;

// Function overloads for better type inference
function validateSometimes(
  validators: ValidationFunction | FlexibleValidationFunction,
  shouldRun: () => boolean
): ValidationFunction;
function validateSometimes(
  validators: (ValidationFunction | FlexibleValidationFunction)[],
  shouldRun: () => boolean
): ValidationFunction[];
function validateSometimes(
  validators:
    | (ValidationFunction | FlexibleValidationFunction)[]
    | ValidationFunction
    | FlexibleValidationFunction,
  shouldRun: () => boolean
): ValidationFunction | ValidationFunction[] {
  if (Array.isArray(validators)) {
    return validators.map(
      (validator: ValidationFunction | FlexibleValidationFunction) =>
        guardValidatorWithCondition(validator, shouldRun)
    );
  } else {
    return guardValidatorWithCondition(validators, shouldRun);
  }

  function guardValidatorWithCondition(
    validator: ValidationFunction | FlexibleValidationFunction,
    shouldRun: () => boolean
  ) {
    return function (
      key: string,
      newValue: unknown,
      oldValue: unknown,
      changes: unknown,
      content: object
    ): ValidationResult | Promise<ValidationResult> {
      if (shouldRun()) {
        return validator(key, newValue, oldValue, changes, content);
      }
      return true;
    };
  }
}

export default validateSometimes;
